export default __webpack_public_path__ + "static/media/BaobabRelatedCareers.0fb419c0.png";